import React from 'react';
import { LayoutChangeEvent, StyleProp, View, ViewStyle } from 'react-native';

type Props = {
  style?: StyleProp<ViewStyle>;
  render: (data: { width: number; height: number }) => React.ReactNode;
};

export const Resizer: React.FC<Props> = ({ style, render }) => {
  const [dims, setDims] = React.useState({ width: 0, height: 0 });

  const handleLayout = ({
    nativeEvent: {
      layout: { width, height },
    },
  }: LayoutChangeEvent) =>
    setDims({
      width,
      height,
    });

  return (
    <View style={style} onLayout={handleLayout}>
      {!!dims.width && render({ width: dims.width, height: dims.height })}
    </View>
  );
};
